
export const CatList = [
  // 
  {
    name: "Exclusive Games",
    related:"",
    path: ["/bestgamespot-games"],
    thumb:"https://cdncloud.cutedressup.in/bestgamespot/website/category-icon/exclusive_cat_icon.png",
  },
  {
    name: "Action Games",
    related:"",
    path: ["/action-games"],
    thumb:"/assets/cat/action-games-icon.png",
  },
  {
    name: "Racing Games",
    related:"",
    path: ["/racing-games"],
    thumb:"/assets/cat/racing-games-icon.png",
  },
  {
    name: "Girl Games",
    related:"",
    path: ["/girl-games"],
    thumb:"/assets/cat/girl-games-icon.png",
  },
  {
    name: "Gamezop Games",
    related:"",
    path: ["/gamezop-games"],
    thumb:"/assets/cat/gamezop-games.png",
  },
  {
    name: "Arcade Games",
    related:"",
    path: ["/arcade-games"],
    thumb:"/assets/cat/arcade-games-icon.png",
  },
  {
    name: "Fighting Games",
    related:"",
    path: ["/fighting-games"],
    thumb:"/assets/cat/fighting-games-icon.png",
  },
  {
    name: "Puzzle Games",
    related:"",
    path: ["/puzzle-games"],
    thumb:"/assets/cat/puzzle-games-icon.png",
  },
  {
    name: "Shooting Games",
    related:"",
    path: ["/shooting-games"],
    thumb:"/assets/cat/shooting-games-icon.png",
  },
  {
    name: "Multiplayer Games",
    related:"",
    path: ["/multiplayer-games"],
    thumb:"/assets/cat/multiplayer-games-icon.png",
  },
  {
    name: "3D Games",
    related:"",
    path: ["/3d-games"],
    thumb:"/assets/cat/3d-games-icon.png",
  },
  {
    name: "IO Games",
    related:"",
    path: ["/io-games"],
    thumb:"/assets/cat/io-games-icon.png",
  },
  {
    name: "Kids Games",
    related:"",
    path: ["/kids-games"],
    thumb:"/assets/cat/kids-games-icon.png",
  },
  {
    name: "Poki Games",
    related:"",
    path: ["/poki-games"],
    thumb:"/assets/cat/poki-games-icon.png",
  },
  {
    name: "Crazy Games",
    related:"",
    path: ["/crazy-games"],
    thumb:"/assets/cat/crazy-games-icon.png",
  },
  {
    name: "Escape Games",
    related:"",
    path: ["/escape-games"],
    thumb:"/assets/cat/escape-games-icon.png",
  },
  {
    name: "Motorbike Games",
    related:"",
    path: ["/motorbike-games"],
    thumb:"/assets/cat/motorbike-games-icon.png",
  },
  {
    name: "Car games",
    related:"",
    path: ["/car-games"],
    thumb:"/assets/cat/car-games-icon.png",
  },
  {
    name: "Subway Surfers Games",
    related:"",
    path: ["/subway-surfers-online"],
    thumb:"/assets/cat/subway-surfers-games-icon.png",
  },
  {
    name: "Sniper Games",
    related:"",
    path: ["/sniper-games"],
    thumb:"/assets/cat/sniper-games-icon.png",
  },
  {
    name: "View All",
    related:"",
    path: ["/all-categories"],
    thumb:"/assets/sidenav/all-tag.svg",
  },
];


